import {Alert, Box, Button, Snackbar, Stack, Typography} from '@mui/material';
import {ArrowBackIosNew} from '@mui/icons-material';
import {useNavigate, useParams} from 'react-router-dom';
import {customerAPI} from '../../../services/CustomerServices';
import {UpdateForm} from '../table/CollapseContent/UpdateForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {getApiErrorKind, getApiErrorMessage, getApiTraceId} from '../../../common/apiErrors';
import {useEffect, useState} from 'react';
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';
import TraceIdFeedback from '../../feedback/TraceIdFeedback';

export const CustomerEditPage = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const {t} = useAppTranslation();
    const {data: customer, isLoading, error} = customerAPI.useGetCustomerByIdV2Query(id ?? '', {skip: !id});
    const [serverToast, setServerToast] = useState('');
    const [traceId, setTraceId] = useState('');

    useEffect(() => {
        if (!error || getApiErrorKind(error) !== 'server') return;
        setServerToast(getApiErrorMessage(error, t));
        setTraceId(getApiTraceId(error));
    }, [error, t]);

    return (
        <Box sx={{width: '100%'}}>
            <Stack spacing={2}>
                <Button variant="outlined" startIcon={<ArrowBackIosNew/>} onClick={() => navigate('..', {relative: 'path'})} sx={{alignSelf: 'flex-start'}}>
                    {t('customers:back_to_customers')}
                </Button>
                <Typography variant="h5">{t('common:edit')} {t('customers:customer_name').toLowerCase()}</Typography>
                {isLoading && <ContentSkeleton variant="form"/>}
                {error && getApiErrorKind(error) !== 'server' && <Alert severity="error">{getApiErrorMessage(error, t)}</Alert>}
                {customer && <UpdateForm item={customer} cancelEdit={() => navigate('..', {relative: 'path'})}/>}
            </Stack>
            <Snackbar open={!!serverToast} autoHideDuration={6000} onClose={() => setServerToast('')}>
                <Alert severity="error" onClose={() => setServerToast('')}>{serverToast}<TraceIdFeedback traceId={traceId}/></Alert>
            </Snackbar>
        </Box>
    );
};
